import React from 'react';

import Typography from '../../typography/typography';

import { useNavigateTo } from '../../../shared/hooks/hooks';

import './tab.scss';

export interface TabProps {
  className?: string;
  href?: string;
  isSecondary?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
}

function Tab(props: React.PropsWithChildren<TabProps>) {
  const { className, children, href, isSecondary, isSelected, onClick } = props;

  const navigateTo = useNavigateTo();

  let styleName = 'primary';
  if (isSecondary) {
    styleName = 'secondary';
  }

  function handleClick() {
    if (!isSelected) {
      if (href) {
        navigateTo(href);
      }
      typeof onClick === 'function' && onClick();
    }
  }

  return (
    <Typography
      aria-selected={isSelected}
      className={`tab ${className} ${
        isSelected ? 'tab--selected' : 'tab--default'
      }`}
      onClick={handleClick}
      role="tab"
      styleName={isSelected ? styleName + '-selected' : styleName}
      tag="button"
    >
      {children}
    </Typography>
  );
}

export default Tab;
